<div [formGroup]="formGroup()" class="form-container">
    <assessment-row title="Provider Notified?">
        <emr-checkbox [control]="formGroup().controls.isNotified" label="Yes"></emr-checkbox>
    </assessment-row>
    @if (formGroup().controls.isNotified.value){
    <assessment-row title="Who">
        <emr-input type="text" [control]="formGroup().controls.notifiedPerson" />
    </assessment-row>
    <assessment-row title="What">
        <emr-input type="text" [control]="formGroup().controls.notifiedWhat" />
    </assessment-row>
    }
</div>